export default function select(obj, path) {
    let res = obj;
    let chunks = path.split("/").filter(c => c);
    for (let chunk of chunks) {
        if (res === null || res[chunk] === void 0) {
            return void 0;
        }
        res = res[chunk];
    }

    return res;
}


// WEBPACK FOOTER //
// ./src/lib/select.js